// client/src/utils/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * This component ensures that on every navigation to a new page (a change in pathname),
 * the window is instantly scrolled to the top. This creates a natural page-change
 * experience and provides the perfect starting point for our entrance animations.
 */
const ScrollToTop = () => {
  // `pathname` is the part of the URL after the domain (e.g., "/about", "/products/dialysis-supplies")
  const { pathname } = useLocation();

  useEffect(() => {
    // This effect runs every single time the `pathname` changes.
    window.scrollTo(0, 0);
  }, [pathname]); // The dependency array ensures it ONLY runs when the path changes.

  // This component renders nothing itself. It's a pure utility.
  return null;
};

export default ScrollToTop;